import { createStore } from 'k-ramel'
import description from './description'
import listeners from './listeners'
import drivers, { router } from './drivers'

export default () => {
  const store = createStore(
    description(router),
    {
      listeners,
      drivers,
    },
  )
  return store
}
